var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.07 18.68l-2.12-4.25-2.13 4.25m.38-.75h3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.95 22v0a5.05 5.05 0 01-5.05-5.05v0a5.05 5.05 0 015.05-5.05v0A5.05 5.05 0 0122 16.95v0A5.05 5.05 0 0116.95 22zM5.1 2.1H9a3 3 0 013 3V9a3 3 0 01-3 3H5.1a3 3 0 01-3-3V5.1a3 3 0 013-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07 5.93H5.03m2.02-.68v.68m1.01 0a3.1 3.1 0 01-3.04 3.15m4.05 0c-.72 0-1.37-.4-1.84-1m7.33-3.16h1.47a3.66 3.66 0 013.66 3.66m-5.13-3.66l1.1 1.1m0-2.2l-1.1 1.1M9.44 19.08H7.97a3.66 3.66 0 01-3.67-3.66m5.14 3.66l-1.1-1.1m0 2.2l1.1-1.1"
  }))));
}
export default SvgTranslate;